import React, { createContext, useContext, useMemo } from 'react';
import { decodeShareTokenPayloadUnsafe } from 'fym-common/src/shareToken/decodeUnsafe';
import { ShareTokenPayload } from 'fym-common/src/shareToken/types';

interface ShareTokenContextValue {
  payload: ShareTokenPayload | null;
  rawToken: string | null;
  isPublicMode: boolean;
}

const ShareTokenContext = createContext<ShareTokenContextValue>({
  payload: null,
  rawToken: null,
  isPublicMode: false,
});

interface ShareTokenProviderProps {
  token?: string | null;
}

export const ShareTokenProvider: React.FC<React.PropsWithChildren<ShareTokenProviderProps>> = ({
  token = null,
  children,
}) => {
  const payload = useMemo(
    () => (token !== null && token !== '' ? decodeShareTokenPayloadUnsafe(token) : null),
    [token]
  );
  const value = useMemo(
    () => ({ payload, rawToken: payload !== null ? token : null, isPublicMode: payload !== null }),
    [payload, token]
  );
  return <ShareTokenContext.Provider value={value}>{children}</ShareTokenContext.Provider>;
};

export const useShareTokenContext = (): ShareTokenContextValue => useContext(ShareTokenContext);
